export const validationStateMixin = {
    methods: {
        getValidationState(validatable, { dirty, validated, valid = null }) {
            if (!validatable) {
                return null;
            }
            return dirty || validated ? valid : null;
        },
    }
};